import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
let global_db2 = null;


export const initializeFSTORE2 = () =>{
    const app2 = initializeApp({
        apiKey: "AIzaSyCB6A5Z1-FE3zmLDtNNw8oLgSL1PxL_Eo4",
        authDomain: "comodin-c9ec5.firebaseapp.com",
        projectId: "comodin-c9ec5",
        storageBucket: "comodin-c9ec5.appspot.com",
        messagingSenderId: "672672344192",
        appId: "1:672672344192:web:73ae9215c14e56a480de65",
        measurementId: "G-92VDTGGQKL"
    },"app2");
    const db2 = getFirestore(app2)
    global_db2 = db2
    return global_db2
}

export const get_global_db_2 = () => {
    return global_db2
}